import "./noProperty.css"
const NoProperty = () => {
  return (
    <div>
      <h1>No Property Added Yet!</h1>
    </div>
  )
}

export default NoProperty